// extracted by mini-css-extract-plugin
module.exports = {"commentActions":"styles-module__commentActions___nZGoG","likesCount":"styles-module__likesCount___2GEPL","likesCountLiked":"styles-module__likesCountLiked___1dJUp"};